import { render } from "./App.vue?vue&type=template&id=140e2f3a&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=140e2f3a&lang=scss"

import exportComponent from "F:\\0bjekt.co\\projects\\2021\\sphere\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__